import { TypographyOptions } from "@mui/material/styles/createTypography";
import breakpoints from "./breakpoints";
import { InternalThemeConfig } from "./config";

const typography = (config: InternalThemeConfig): TypographyOptions => ({
	fontWeightLight: 300,
	fontWeightRegular: 400,
	fontWeightMedium: 500,
	fontWeightBold: 700,
	allVariants: {
		fontFamily: "RoobertCEZ",
		fontWeight: undefined,
		fontSize: "1.6rem",
		fontStyle: undefined,
		letterSpacing: undefined,
		lineHeight: "2rem",
	},
	h1: {
		fontWeight: "bold",
		fontSize: "3.2rem",
		lineHeight: "4rem",
		letterSpacing: "0.02em",
		textTransform: "uppercase",

		[`@media (min-width:${breakpoints.values.md}px)`]: {
			fontSize: "4.8rem",
			lineHeight: "5.6rem",
		},
	},
	h2: {
		fontSize: "2.6rem",
		fontStyle: "normal",
		fontWeight: 700,
		lineHeight: "2.6rem",
	},
	h3: {
		fontWeight: 400,
		fontSize: "2.4rem",
		lineHeight: "3.2rem",
		textTransform: "none",

		[`@media (min-width:${breakpoints.values.md}px)`]: {
			fontWeight: 400,
			fontSize: "2.4rem",
			lineHeight: "3.2rem",
		},
	},
	h4: {
		fontSize: "1.4rem",
		fontStyle: "normal",
		fontWeight: 700,
		lineHeight: "1.8rem",
		color: config.palette.textSecondary,
		[`@media (min-width:${breakpoints.values.md}px)`]: {
			fontSize: "1.6rem",
			lineHeight: "2.2rem",
			fontWeight: 500,
		},
	},
	h5: {
		fontWeight: 600,
		fontSize: "1.4rem",
		lineHeight: "2rem",
		textTransform: "uppercase",
		letterSpacing: "0.02em",
		[`@media (min-width:${breakpoints.values.md}px)`]: {
			fontSize: "1.6rem",
			lineHeight: "2.2rem",
		},
	},
	h6: {
		fontWeight: 600,
		fontSize: "1.6rem",
		lineHeight: "2.4rem",
		letterSpacing: "0.01em",
		[`@media (min-width:${breakpoints.values.md}px)`]: {
			fontSize: "1.6rem",
		},
	},
	body1: {
		lineHeight: "2.6rem",
		fontSize: "1.6rem",
		fontWeight: "normal",
		"&&.MuiTypography-gutterBottom": {
			marginBottom: "2.4rem",
		},
		[`@media (min-width:${breakpoints.values.md}px)`]: {
			"&&.MuiTypography-gutterBottom": {
				marginBottom: "3.2rem",
			},
		},
	},
	body2: {
		fontSize: "1.2rem",
		lineHeight: "1.6rem",
		fontWeight: 400,
	},
	caption: {
		lineHeight: "1.7rem",
		fontSize: "1rem",
		fontWeight: 400,
	},
	subtitle1: {
		lineHeight: "2.4rem",
		fontSize: "1.6rem",
		fontWeight: 400,
		letterSpacing: "0.2px",
	},
	button: {
		letterSpacing: "0.01em",
		lineHeight: "1.6rem",
		fontSize: "1.6rem",
		fontWeight: 600,
		textTransform: "uppercase",
	},
});

export default typography;
